export default __webpack_public_path__ + "static/media/socialfi_coin_video.6a5425a9.mov";